// extracted by mini-css-extract-plugin
export default {"Error":"h62mN9vN","Text":"YKjri22w","Buttons":"RsJOeR3u","isMobile":"C7QDX2tB"};